'use strict';

(function () {

  angular.module('specsguardApp')
    .config(AreaTemplateConfig);

  AreaTemplateConfig.$inject = ['$stateProvider'];

  function AreaTemplateConfig ($stateProvider) {
    $stateProvider

      .state('areatemplate', {
        url: '/area_template/{areaTemplateId:int}',
        templateUrl: 'app-legacy/area_template/area_template.html',
        controller: 'AreaTemplateCtrl',
        controllerAs: '$AreaTemplateCtrl',
        menu: {
          context: 'technical_template',
          title: '[Technical_templates]',
          subtitle: '[Ruimte templates]',
          icon: 'folder_empty'
        },
        params: {
          areaTemplateId: { squash: true, value: null }
        },
        authenticate: true,
        needRole: 7,
        resolve: {
          technicalElements: ['TechnicalElementsAPI', function (TechnicalElementsAPI) {
            return TechnicalElementsAPI.getFull().$promise;
          }],
          areaTemplates: ['AreaTemplateAPI', function (AreaTemplateAPI) {
            return AreaTemplateAPI.getAll().$promise;
          }],
          constants: ['Constants', function (Constants) {
            return Constants.getConstants();
          }]
        }
      });
  }

}());
